import * as React from 'react';
import { useSelector } from 'react-redux';

import { EMediaType, TMedia } from 'shared/components/NewbuildingGallery';
import { NewbuildingPushToCallBannerContainer } from 'shared/containers/NewbuildingPushToCallBanner';
import { isNewbuildingSelector } from 'shared/selectors';
import { selectIsNewbuildingPushToCallEnabled } from 'shared/selectors/abExperiments';
import { getOffer } from 'shared/selectors/newObject';
import { isLeadFactory } from 'shared/utils/agent';

export const usePushToCallBanner = (thumbnailSrc: string): TMedia | null => {
  const isPushToCallEnabled = useSelector(selectIsNewbuildingPushToCallEnabled);
  const isNewbuilding = useSelector(isNewbuildingSelector);
  const offer = useSelector(getOffer);

  return React.useMemo<TMedia | null>(() => {
    const isFromDeveloper = Boolean(offer.newbuilding?.isFromDeveloper);
    const isAvailable = isFromDeveloper && !isLeadFactory(offer);

    if (!isPushToCallEnabled || !isNewbuilding || !isAvailable) {
      return null;
    }

    return {
      type: EMediaType.Component,
      component: <NewbuildingPushToCallBannerContainer />,
      thumbnailSrc,
    };
  }, [isPushToCallEnabled, isNewbuilding, thumbnailSrc, offer]);
};
